import { createTheme } from '@mui/material/styles';

//예약하기 화면 disabled 상태 스타일
export const disabledTheme = createTheme({
  components: {
    // TextField (회의 제목, 회의 내용), Select (회의실 선택, 참석자 추가),
    // 그리고 Mui X Pickers (시작/종료 시간)에 공통 적용
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: 'transparent', 
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23)', 
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23)', 
            },
            // Mui X Pickers의 내부 섹션 텍스트 색상 조절 (disabled 시)
            // 'MuiPickersInputBase-section' 클래스를 직접 타겟팅합니다.
            '& .MuiPickersInputBase-section': { 
              color: 'rgba(0, 0, 0, 0.87) !important', // 날짜/시간 섹션 텍스트 색상
              '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
              opacity: 1,
            },
          },
        },
        input: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.87) !important', 
            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important', 
            opacity: 1, 
          }
        }
      }
    },
    // 모든 Input Label (예: '회의실 선택', '시작 시간' 등)
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.6) !important', 
          }
        }
      }
    },
    // Select 컴포넌트의 드롭다운 아이콘 및 선택 값
    MuiSelect: {
      styleOverrides: {
        icon: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.54) !important', 
            opacity: 1 
          }
        },
        select: {
            '&.Mui-disabled': {
                color: 'rgba(0, 0, 0, 0.87) !important',
                '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
                opacity: 1,
            }
        }
      }
    },
    // 캘린더 아이콘 (MuiIconButton)
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.54) !important', 
            opacity: 1 
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            opacity: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            color: 'rgba(0, 0, 0, 0.87)',
          }
        }
      }
    },
    MuiTextField: { // Picker 컴포넌트는 내부적으로 MuiTextField를 사용합니다.
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            // MuiPickersInputBase-section 클래스를 가진 스팬 요소의 색상 변경
            // 이는 '시작 시간', '종료 시간' 필드의 날짜/시간 텍스트에 직접 영향을 줍니다.
            '& .MuiPickersInputBase-section': {
              color: 'rgba(0, 0, 0, 0.87) !important',
              '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
              opacity: 1,
            },
            // 혹시 TextField의 직접적인 input에도 영향을 미칠 경우 대비
            '& .MuiInputBase-input': {
              color: 'rgba(0, 0, 0, 0.87) !important',
              '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
              opacity: 1,
            },
            // TextField의 라벨과 아이콘 등 기타 요소에 대한 색상 보정
            '& .MuiInputLabel-root': {
              color: 'rgba(0, 0, 0, 0.6) !important',
            },
            '& .MuiInputAdornment-root .MuiSvgIcon-root': { // 아이콘 색상
              color: 'rgba(0, 0, 0, 0.54) !important',
            },
            // 아웃라인 색상
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23) !important',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23) !important',
            },
          }
        }
      }
    }
  }
});

export default disabledTheme; 
